import { VLabel } from 'vuetify/lib/components/VLabel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spaceTemplateInstruction"}},[_c('div',{staticClass:"instructionWrapper"},[_c('div',{staticClass:"editorWrap"},[_c(VLabel,[_c('span',[_vm._v(_vm._s(_vm.$t("common.instructions")))])]),_c('html-editor',{model:{value:(_vm.instruction),callback:function ($$v) {_vm.instruction=$$v},expression:"instruction"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }